import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { Mail, ArrowLeft, Loader, CheckCircle } from 'lucide-react';

const ForgotPasswordScreen = ({ onBackToLogin }) => {
  const { resetPassword, loading } = useAuth();
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    
    try {
      const result = await resetPassword(email);
      if (result.success) {
        setSuccess(true);
      } else {
        setError('Failed to send reset link. Please try again.');
      }
    } catch (err) {
      setError('Failed to send reset link. Please try again.');
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-container">
        {/* Back Button */}
        <button onClick={onBackToLogin} className="back-button">
          <ArrowLeft size={20} />
          <span>{t('backToSignIn')}</span>
        </button>

        {/* Header */}
        <div className="auth-header">
          <h1 className="auth-title">{t('resetPassword')}</h1>
          <p className="auth-subtitle">
            {success 
              ? t('passwordResetSent')
              : "Enter your email address and we'll send you a link to reset your password"
            }
          </p>
        </div>

        {success ? (
          /* Success State */
          <div className="success-state">
            <div className="success-icon">
              <CheckCircle size={64} />
            </div>
            <p className="success-message">
              {t('passwordResetSent')}
            </p>
            <button onClick={onBackToLogin} className="auth-button primary">
              {t('backToSignIn')}
            </button>
          </div>
        ) : (
          /* Reset Form */
          <form onSubmit={handleSubmit} className="auth-form">
            {error && <div className="error-message">{error}</div>}
            
            <div className="input-group">
              <div className="input-icon">
                <Mail size={18} />
              </div>
              <input
                type="email"
                placeholder={t('enterEmail')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="auth-input"
              />
            </div>

            <button type="submit" disabled={loading} className="auth-button primary">
              {loading ? <Loader size={20} className="spinner" /> : t('sendResetLink')}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordScreen;